import { QueryParams } from '../hooks/global/useApi';

export const defaultReactQueryParams: Partial<QueryParams> = {
  retry: false,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};
